<template>
  <footer class="py-4 brand-bgcolor">
    <div class="navbar">
      <div class="col-sm-12 p-0 text-center">
        <ul class="list-inline mb-0" id="footer-nav">
          <li class="list-inline-item" v-html="$t('Footer.T&CLink')"></li>
          <li
            class="list-inline-item"
            v-html="$t('Footer.PrivayPolicyLink')"
          ></li>
          <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')"></li>
          <li
            class="list-inline-item"
            v-html="$t('Footer.SnippPrivacyPolicyLink')"
          ></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;
    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;
    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>
